"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _rsManagement = require("@/api/rsManagement");
var _pageCache = require("@/utils/pageCache");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var SCENE_TYPE_MAP = {
  1: '外卖',
  2: '自提',
  3: '酒店',
  4: '团购'
};
var _default = exports.default = {
  name: 'ReceiptTemplateList',
  data: function data() {
    return {
      templates: [],
      searchTerm: '',
      page: 1,
      pageSize: 10,
      total: 0,
      listLoading: false
    };
  },
  mounted: function mounted() {
    this.loadList();
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      return (0, _pageCache.refreshOnCacheReentry)(vm, vm.loadList);
    });
  },
  methods: {
    loadList: function loadList() {
      var _this = this;
      this.listLoading = true;
      (0, _rsManagement.getTicketTemplateList)({
        page: this.page,
        limit: this.pageSize,
        templateName: (this.searchTerm || '').trim() || undefined
      }).then(function (res) {
        _this.templates = (res.list || []).map(function (item) {
          return _objectSpread(_objectSpread({}, item), {}, {
            isDefault: Number(item.isDefault) === 1
          });
        });
        _this.total = res.total || 0;
      }).catch(function () {
        _this.templates = [];
        _this.total = 0;
      }).finally(function () {
        _this.listLoading = false;
      });
    },
    handleSearch: function handleSearch() {
      this.page = 1;
      this.loadList();
    },
    resetSearch: function resetSearch() {
      this.searchTerm = '';
      this.page = 1;
      this.loadList();
    },
    handleSizeChange: function handleSizeChange(size) {
      this.pageSize = size;
      this.page = 1;
      this.loadList();
    },
    handleCreate: function handleCreate() {
      this.$router.push({
        path: '/rsManagement/receiptTemplate/edit/new'
      });
    },
    handleEdit: function handleEdit(row) {
      this.$router.push({
        path: "/rsManagement/receiptTemplate/edit/".concat(row.id)
      });
    },
    handleCopy: function handleCopy(row) {
      this.$router.push({
        path: '/rsManagement/receiptTemplate/edit/new',
        query: {
          copyFrom: row.id
        }
      });
    },
    handleDelete: function handleDelete(row) {
      var _this2 = this;
      this.$confirm("\u786E\u5B9A\u5220\u9664\u6A21\u677F\u300C".concat(row.templateName || '', "\u300D\u5417\uFF1F"), '提示', {
        type: 'warning',
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        return (0, _rsManagement.deleteTicketTemplate)(row.id);
      }).then(function () {
        _this2.$message.success('删除成功');
        _this2.loadList();
      }).catch(function () {});
    },
    handleToggleDefault: function handleToggleDefault(row) {
      var _this3 = this;
      (0, _rsManagement.switchTicketTemplateDefault)({
        id: row.id,
        isDefault: row.isDefault ? 1 : 0
      }).then(function () {
        _this3.$message.success('更新成功');
        _this3.loadList();
      }).catch(function () {
        row.isDefault = !row.isDefault;
      });
    },
    formatSceneType: function formatSceneType(type) {
      return SCENE_TYPE_MAP[Number(type)] || '-';
    },
    formatTime: function formatTime(t) {
      if (!t) return '-';
      var d = new Date(t);
      return isNaN(d.getTime()) ? t : d.toLocaleString();
    }
  }
};